import { SignUp } from "@clerk/clerk-react";
import { Box } from "@mui/material";

/**
 * Sign Up Page with Clerk Authentication
 * Uses Clerk's pre-built SignUp component with Material-UI styling
 */
export default function ClerkSignUpPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <SignUp
        routing="path"
        path="/clerk-signup"
        signInUrl="/signin"
        redirectUrl="/tables"
      />
    </Box>
  );
}
